/**
 * MobilityModule — admin OS surface for the /mobility pillar.
 *
 * Flights, chauffeur cars, intercity transfers.
 */
import React from "react";
import Placeholder from "@/pages/admin/os/Placeholder";

export default function MobilityModule() {
  return (
    <Placeholder
      title="Mobility · Admin"
      phase="Phase 2"
      testid="os-modules-mobility"
      description="Movement requests · flights via Amadeus, car routings, intercity transfers. Brief queue is in Operate → Requests."
      willInclude={[
        "Driver roster per city · founder-vetted chauffeur partners",
        "Flight-class override rules (J / F / private)",
        "Intercity transfer routes (Mumbai → Pune, Delhi → Jaipur, etc.)",
        "Mobility brief queue & confirmation pipeline",
      ]}
    />
  );
}
